import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-demande-hospitalisation',
  templateUrl: './demande-hospitalisation.component.html',
  styleUrls: ['./demande-hospitalisation.component.scss']
})
export class DemandeHospitalisationComponent implements OnInit {
  configuration=this.configurationService.get();

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
